import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _split from 'lodash/split';
import _parseInt from 'lodash/parseInt';
import _isEmpty from 'lodash/isEmpty';
// Core components
import Paper from 'components/core/Paper';
import Typography from 'components/core/Typography';
// Custom
import { deviceDataShape, installationLogScenarioLogActionDataShape } from 'constants/PropTypesShapes';
import { successWarningIconColor } from 'utils/Tools';
import ActionRelayItem from 'installations/assets/scenarios/ActionRelayItem';
import AppIcon from 'components/icons/AppIcon';
import ScenarioLogExecActionInputsEventsItem from './ScenarioLogExecActionInputsEventsItem';

const ScenarioLogActionItemElementItem = ({ action, device }) => {
  const statusIconColor = successWarningIconColor(action.success);
  // Actions information
  const relayActions = action.expression !== '' ? _split(action.expression, ';').sort() : null;
  // Build input events
  const inputsEvents = _map(action.time, (value, key) => ({ delay: _parseInt(key), expression: value }));

  return (
    <Paper className="p-2 mb-3">
      {relayActions && (
        <React.Fragment>
          <div className="d-flex align-items-center pb-2">
            <AppIcon color={statusIconColor.color} id={statusIconColor.icon} />
            <Typography type="subtitle" className="ml-2">
              <LocalizedMessage id="subtitle.actions" />
            </Typography>
          </div>
          <div className="information-item-wrapper">
            {!!relayActions && _map(relayActions, (relayAction) => (
              <ActionRelayItem
                key={relayAction}
                relayAction={relayAction}
                device={device}
              />
            ))}
          </div>
        </React.Fragment>
      )}
      {inputsEvents && !_isEmpty(inputsEvents) && (
        <ScenarioLogExecActionInputsEventsItem
          inputsEvents={inputsEvents}
          device={device}
          actionDelay={action.delay}
        />
      )}
    </Paper>
  );
};

ScenarioLogActionItemElementItem.propTypes = {
  action: installationLogScenarioLogActionDataShape.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogActionItemElementItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecActionElementItem.js